import { useNostr } from '@nostrify/react';
import { useQuery } from '@tanstack/react-query';
import { useCurrentUser } from './useCurrentUser';
import { parseStall, type Stall } from '@/lib/marketplace';
import type { NostrEvent } from '@nostrify/nostrify';

export interface StallEvent {
  event: NostrEvent;
  stall: Stall;
}

/** Fetch the current user's own kind:30017 stalls */
export function useMyStalls() {
  const { nostr } = useNostr();
  const { user } = useCurrentUser();

  return useQuery<StallEvent[]>({
    queryKey: ['my-stalls', user?.pubkey],
    queryFn: async () => {
      if (!user?.pubkey) return [];
      const events = await nostr.query(
        [{ kinds: [30017], authors: [user.pubkey], limit: 100 }],
        { signal: AbortSignal.timeout(10000) }
      );
      const result: StallEvent[] = [];
      for (const event of events) {
        const stall = parseStall(event.content);
        if (stall) result.push({ event, stall });
      }
      return result;
    },
    enabled: !!user?.pubkey,
    staleTime: 30000,
  });
}
